import { QueryClient } from '@tanstack/react-query';
import { queryClientConfig } from '@marqvision/shared/config/react-query';
import { http } from '~/apis/base';
import { AssetPiracy } from '~/swagger/AssetPiracy';
import { Auth } from '~/swagger/Auth';
import { AuthorizedListPiracy } from '~/swagger/AuthorizedListPiracy';
import { AuthorizedSeller } from '~/swagger/AuthorizedSeller';
import { AuthorizedSellerKeywordFiltering } from '~/swagger/AuthorizedSellerKeywordFiltering';
import { AuthorizedWebsite } from '~/swagger/AuthorizedWebsite';
import { Billing } from '~/swagger/Billing';
import { Common } from '~/swagger/Common';
import { ConversationalAssistant } from '~/swagger/ConversationalAssistant';
import { CopyrightedImage } from '~/swagger/CopyrightedImage';
import { Cr } from '~/swagger/Cr';
import { CustomTag } from '~/swagger/CustomTag';
import { Email } from '~/swagger/Email';
import { EmployeeSignup } from '~/swagger/EmployeeSignup';
import { GenerativeAiPiracy } from '~/swagger/GenerativeAiPiracy';
import { Home } from '~/swagger/Home';
import { HomePiracy } from '~/swagger/HomePiracy';
import { InfringingImage } from '~/swagger/InfringingImage';
import { IpPortfolio } from '~/swagger/IpPortfolio';
import { LSettings } from '~/swagger/LSettings';
import { Map } from '~/swagger/Map';
import { MonitoringDetected } from '~/swagger/MonitoringDetected';
import { MonitoringEnforcementTp } from '~/swagger/MonitoringEnforcementTp';
import { MonitoringFilter } from '~/swagger/MonitoringFilter';
import { MonitoringWebsiteContents } from '~/swagger/MonitoringWebsiteContents';
import { MonitoringWebsiteDomainNames } from '~/swagger/MonitoringWebsiteDomainNames';
import { Password } from '~/swagger/Password';
import { Performance } from '~/swagger/Performance';
import { PerformanceDetailsCompRate } from '~/swagger/PerformanceDetailsCompRate';
import { PerformanceDetailsImpactedSellers } from '~/swagger/PerformanceDetailsImpactedSellers';
import { PerformanceImpersonation } from '~/swagger/PerformanceImpersonation';
import { SellerAnalyticsCluster } from '~/swagger/SellerAnalyticsCluster';
import { SellerAnalyticsDataDriven } from '~/swagger/SellerAnalyticsDataDriven';
import { SellerAnalyticsDetail } from '~/swagger/SellerAnalyticsDetail';
import { SellerAnalyticsSeller } from '~/swagger/SellerAnalyticsSeller';
import { SellerIntelligence } from '~/swagger/SellerIntelligence';
import { Settings } from '~/swagger/Settings';
import { SocialMediaPiracy } from '~/swagger/SocialMediaPiracy';
import { Storage } from '~/swagger/Storage';
import { SwComment } from '~/swagger/SwComment';
import { WebsiteContentsPiracy } from '~/swagger/WebsiteContentsPiracy';

// Home
export const homeApi = new Home(http);
export const homePiracyApi = new HomePiracy(http);
export const homeCrApi = new Cr(http);

// Performance
export const performanceApi = new Performance(http);
export const impersonationPerformanceApi = new PerformanceImpersonation(http);
export const performanceSellerApi = new PerformanceDetailsImpactedSellers(http);
export const performanceComplianceRateApi = new PerformanceDetailsCompRate(http);

// Portfolio
export const portfolioApi = new IpPortfolio(http);
export const copyrightedImageApi = new CopyrightedImage(http);
export const assetPiracyApi = new AssetPiracy(http);

export const authorizedSellerApi = new AuthorizedSeller(http);
export const authorizedSellerKeywordFilterApi = new AuthorizedSellerKeywordFiltering(http);
export const authorizedWebsiteAPI = new AuthorizedWebsite(http);
export const authorizedListPiracyApi = new AuthorizedListPiracy(http);

// Enforcements
export const monitoringEnforcementTpApi = new MonitoringEnforcementTp(http);
export const monitoringFilterApi = new MonitoringFilter(http);

// Monitoring Details

export const monitoringDetectedApi = new MonitoringDetected(http);

// Website Content
export const websiteContentApi = new MonitoringWebsiteContents(http);
export const websiteContentsPiracyApi = new WebsiteContentsPiracy(http);

// Social Media
export const socialMediaPiracyApi = new SocialMediaPiracy(http);

// Domain Names
export const domainNamesApi = new MonitoringWebsiteDomainNames(http);

// Conversational Assistant
export const conversationalAssistantApi = new ConversationalAssistant(http);

// Seller
export const sellerAnalyticsClusterApi = new SellerAnalyticsCluster(http);
export const sellerAnalyticsDetailApi = new SellerAnalyticsDetail(http);
export const sellerAnalyticsSellerApi = new SellerAnalyticsSeller(http);
export const sellerIntelligenceApi = new SellerIntelligence(http);

export const sellerAnalyticsDetailDataDriven = new SellerAnalyticsDataDriven(http);

// Map Monitoring

export const mapMonitoringApi = new Map(http);

// Settings
export const legacySettingsApi = new LSettings(http);
export const settingsApi = new Settings(http);
export const billingApi = new Billing(http);
export const passwordApi = new Password(http);
export const emailApi = new Email(http);
export const authApi = new Auth(http);
export const employeeSignupApi = new EmployeeSignup(http);
export const infringingImageApi = new InfringingImage(http);
export const customTagApi = new CustomTag(http);

// common
export const storageApi = new Storage(http);
export const commonApi = new Common(http);

// Comment
export const swCommentApi = new SwComment(http);

// Generative AI
export const generativeAiPiracyApi = new GenerativeAiPiracy(http);

export const queryClient = new QueryClient(queryClientConfig);
